import { createSlice } from '@reduxjs/toolkit';
import {
    aguaDulceNodo,
} from '../actions/aguaDulceNodo';


export const AguaDulceReducerNodo = createSlice({
    name: 'aguaDulceNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(aguaDulceNodo.pending, (state) => { state.loading = true })
            .addCase(aguaDulceNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(aguaDulceNodo.rejected, (state) => { state.loading = false })
    }
})

export default AguaDulceReducerNodo.reducer;
